module.exports = __webpack_public_path__ + "media/applications/assets/images/materials/hoodie/2-2-9178550874051b2fc292f4b53785fb22.jpg";